export default function getBackgroundStyle(url) {
  const background = url && `#fff url(${url}) center center / cover no-repeat`;
  return { background };
}
